import { ID_OPPOSITION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-opposition';
import { CodeSubject } from 'civil-status/constants/code-subject-section';
import { SectionVM, ParentVM, UnioneCivileAtti } from 'civil-status/view-models/step-form';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';
import { DESCRIPTION_ITALIAN_NATION, ID_ITALIAN_NATION } from 'shell/constants/id-italian-nation';

export const transformerUnioneCivileAtti = (
  idEvento?: number,
  dataSection?: SectionVM,
  testoDelegaUnioneCivile?: SectionVM,
  subjectOfficiante?: ParentVM,
  subjectUniciv?: Array<ParentVM>,
  subjectUnicivScio?: Array<ParentVM>,
  subjectSegrCiv?: ParentVM,
  dataCivilUnion?: SectionVM
): UnioneCivileAtti | undefined => {
  if (
    !(
      dataSection ||
      testoDelegaUnioneCivile ||
      subjectOfficiante ||
      (subjectUniciv || [])?.length > 0 ||
      (subjectUnicivScio || [])?.length > 0 ||
      dataCivilUnion ||
      subjectSegrCiv
    )
  ) {
    return undefined;
  }

  const subjectUniciv1 = subjectUniciv?.find((item) => item.codeSubject === CodeSubject.UNICIV1);
  const subjectUniciv2 = subjectUniciv?.find((item) => item.codeSubject === CodeSubject.UNICIV2);

  const subjectUniciv1Scio = subjectUnicivScio?.find(
    (item) => item.codeSubject === CodeSubject.UNICIV1_SCIO
  );
  const subjectUniciv2Scio = subjectUnicivScio?.find(
    (item) => item.codeSubject === CodeSubject.UNICIV2_SCIO
  );

  const isOtherMunicipality =
    dataSection?.italianDelegating?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

  return {
    key: {
      idEvento,
    },
    dataEvento: dataSection?.dateEvent
      ? dataSection?.dateEvent?.toFormat('yyyy-MM-dd')
      : dataCivilUnion?.dataCivilUnion
      ? dataCivilUnion?.dataCivilUnion?.toFormat('yyyy-MM-dd')
      : undefined,
    oraEvento: dataSection?.timeEvent
      ? Number.parseInt(dataSection?.timeEvent.toFormat('HH'), 10)
      : undefined,
    minutoEvento: dataSection?.timeEvent
      ? Number.parseInt(dataSection?.timeEvent.toFormat('mm'), 10)
      : undefined,
    numeroTestimoni: dataSection?.numberWitnesses
      ? Number.parseInt(dataSection?.numberWitnesses, 10)
      : undefined,
    flagRigettoOpposizione: dataSection
      ? dataSection?.opposition === ID_OPPOSITION.ID_DECRETO
        ? '1'
        : '0'
      : undefined,
    flagEstintaOpposizione: dataSection
      ? dataSection?.opposition === ID_OPPOSITION.ID_PROVVEDIMENTO
        ? '1'
        : '0'
      : undefined,
    tipoImpedimentoGenerico: dataSection?.genericImpediment || undefined,
    tipoSoggettoConImpedimento: dataSection?.impedimentUnitedCivilly || undefined,
    dataDelega: dataSection?.dataDelegate
      ? dataSection?.dataDelegate?.toFormat('yyyy-MM-dd')
      : undefined,
    testoDelega: testoDelegaUnioneCivile?.actComposition || undefined,
    idNazioneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? ID_ITALIAN_NATION
      : Number.parseInt(dataSection?.foreignDelegating?.state?.code || '', 10),
    nomeNazioneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? DESCRIPTION_ITALIAN_NATION
      : dataSection?.foreignDelegating?.state?.value,
    idConsolatoDelegante: dataSection?.foreignDelegating?.consulate?.id?.toString()
      ? Number.parseInt(dataSection.foreignDelegating?.consulate?.id?.toString(), 10)
      : undefined,
    nomeConsolatoDelegante: dataSection?.foreignDelegating?.consulate?.value || undefined,
    idComuneDelegante: dataSection?.italianDelegating?.municipality?.code?.toString()
      ? Number.parseInt(dataSection?.italianDelegating?.municipality?.code.toString(), 10)
      : undefined,
    nomeComuneDelegante: isOtherMunicipality
      ? dataSection?.italianDelegating?.otherMunicipality || undefined
      : dataSection?.italianDelegating?.municipality?.description,
    idProvinciaDelegante: dataSection?.italianDelegating?.municipality?.idProvince || undefined,
    siglaProvinciaDelegante: dataSection?.italianDelegating?.municipality?.province || undefined,
    tipoOfficiante: subjectOfficiante?.generality?.ufcDelegate || undefined,
    tipoComprensioneConiuge1:
      subjectUniciv1?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimentoScritturaConiuge1:
      subjectUniciv1?.generality?.reasonImpediment || undefined,
    tipoComprensioneConiuge2:
      subjectUniciv2?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimentoScritturaConiuge2:
      subjectUniciv2?.generality?.reasonImpediment || undefined,
    tipoRuoloSegretario: subjectSegrCiv?.generality?.roloSecretary || undefined,
    flagConiuge1InPericoloVita:
      subjectUniciv1 || subjectUniciv1Scio
        ? subjectUniciv1?.generality?.isImminentDangerOfLife ||
          subjectUniciv1Scio?.generality?.isImminentDangerOfLife
          ? '1'
          : '0'
        : undefined,
    descrizioneAccertamentoVolontaConiuge1:
      subjectUniciv1?.generality?.verificationOfWill ||
      subjectUniciv1Scio?.generality?.verificationOfWill ||
      undefined,
    flagConiuge2InPericoloVita:
      subjectUniciv2 || subjectUniciv2Scio
        ? subjectUniciv2?.generality?.isImminentDangerOfLife ||
          subjectUniciv2Scio?.generality?.isImminentDangerOfLife
          ? '1'
          : '0'
        : undefined,
    descrizioneAccertamentoVolontaConiuge2:
      subjectUniciv2?.generality?.verificationOfWill ||
      subjectUniciv2Scio?.generality?.verificationOfWill ||
      undefined,
  };
};
